import { useState, useEffect } from 'react';
import { Download, User, Image, Clock, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { adminFetch } from '../../utils/adminFetch';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminDownloadLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const response = await adminFetch(`${API}/admin/download-logs`);
      if (response.ok) {
        const data = await response.clone().json();
        setLogs(data);
      }
    } catch (error) {
      console.error('Error fetching download logs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchLogs(); }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="space-y-6" data-testid="download-logs-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl">Registro de Descargas</h1>
          <p className="text-sm text-muted-foreground mt-1">{logs.length} descargas registradas</p>
        </div>
        <Button variant="outline" size="sm" onClick={fetchLogs} disabled={loading} data-testid="refresh-logs-btn">
          <RefreshCw className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
          Actualizar
        </Button>
      </div>

      {loading && logs.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">Cargando...</div>
      ) : logs.length === 0 ? (
        <div className="text-center py-12 border border-dashed border-border rounded-lg">
          <Download className="w-12 h-12 mx-auto mb-3 text-muted-foreground opacity-30" />
          <p className="text-muted-foreground">No hay descargas registradas</p>
        </div>
      ) : (
        <div className="border border-border rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-muted/50 border-b border-border">
                <th className="text-left p-3 font-medium">Cliente</th>
                <th className="text-left p-3 font-medium">Galería</th>
                <th className="text-left p-3 font-medium">Fotos</th>
                <th className="text-left p-3 font-medium">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={log.log_id || i} className="border-b border-border last:border-0 hover:bg-muted/30 transition-colors" data-testid={`download-log-${i}`}>
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                      <User className="w-4 h-4 text-muted-foreground" />
                      <div>
                        <p className="font-medium">{log.client_name}</p>
                        <p className="text-xs text-muted-foreground">{log.client_email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                      <Image className="w-4 h-4 text-muted-foreground" />
                      <span>{log.gallery_title}</span>
                    </div>
                  </td>
                  <td className="p-3 text-muted-foreground">{log.image_count}</td>
                  <td className="p-3">
                    <div className="flex items-center gap-2 text-muted-foreground">
                      <Clock className="w-3 h-3" />
                      <span className="text-xs">{formatDate(log.downloaded_at)}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminDownloadLogs;
